// extracted by mini-css-extract-plugin
export default {"root":"style_root__MlRzR","segmentedControl":"style_segmentedControl__FUF4Y","city":"style_city__Ypqcp","cartographyLoader":"style_cartographyLoader__moGjK"};